var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCongratulations = function SvgCongratulations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#86D684"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M23.31 37.167h.5v-.074a1.96 1.96 0 0 0 .89-.472L41.078 21.37a1.806 1.806 0 0 0 0-2.669 2.05 2.05 0 0 0-2.762 0L23.294 32.674l-5.277-4.914a2.05 2.05 0 0 0-2.761 0 1.806 1.806 0 0 0 0 2.669l6.666 6.207.005.005.005.005c.388.34.882.52 1.379.52Z"
  })));
};
export default SvgCongratulations;